import { IListOfBooking } from "layout/services/dtos";
import { createContext, useContext } from "react";

// Define the context type
export interface SupplierInfoContextType {
    isAuthenticated: boolean;
    supplierId: string;
    supplierName: string;
    bookingList: IListOfBooking[] | undefined;
}

// Create SupplierInfoContext
export const SupplierInfoContext = createContext<
    SupplierInfoContextType | undefined
>(undefined);

// Custom hook to access the context
export const useSupplierInfo = () => {
    const context = useContext(SupplierInfoContext);
    if (!context) {
        throw new Error(
            "useSupplierInfo must be used within a SupplierInfoProvider"
        );
    }
    return context;
};

// SupplierInfoProvider Component
export const SupplierInfoProvider = ({
    children,
    isAuthenticated,
    supplierId,
    supplierName,
    bookingList
}: {
    children: React.ReactNode;
    isAuthenticated: boolean;
    supplierId: string;
    supplierName: string;
    bookingList: IListOfBooking[] | undefined;
}) => {
    return (
        <SupplierInfoContext.Provider
            value={{ isAuthenticated, supplierId, supplierName, bookingList }}
        >
            {children}
        </SupplierInfoContext.Provider>
    );
};
